import { message } from '@tauri-apps/plugin-dialog';
import { relaunch } from '@tauri-apps/plugin-process';
import { check } from '@tauri-apps/plugin-updater';

import logger from '$lib/logger';

export const checkForAppUpdates = async () => {
  logger.info('Checking for tauri update....');
  const update = await check();

  if (!update?.version) {
    logger.debug('Null update');
    return;
  }

  logger.info(`found update ${update.version} from ${update.date}`, { notes: update.body });

  let contentLength = 0;

  await update.downloadAndInstall((event) => {
    switch (event.event) {
      case 'Started':
        contentLength = event.data.contentLength!;
        logger.debug(`started downloading ${contentLength} bytes`);
        break;
      case 'Finished':
        logger.debug('download finished');
        break;
    }
  });

  logger.info('update installed');
  await message(
    `RoastLogger has been updated from verion ${update.currentVersion} to ${update.version}.
    Click Ok to relaunch the application and pick up the latest changes!`,
    { title: `RoastLogger updated to ${update.version}`, kind: 'info' }
  );
  await relaunch();
};
